// extracted by mini-css-extract-plugin
export var hidden = "_u8-0";